<template>
  <div>
    <com-page>
      <com-order-search @search="handleSearch" @onExport="handleExport"></com-order-search>
      <com-card>
        <com-order-list
          ref="orderListRef"
          :api="api"
          :defaultParams="defaultParams"
        ></com-order-list>
      </com-card>
    </com-page>
  </div>
</template>

<script>
import { orderListApi } from '@/api/order'
import utils from 'my-tools-library'

export default {
  data() {
    return {
      api: orderListApi,
      defaultParams: {
        status: 4
      },
      exportQuery: {}
    }
  },
  methods: {
    handleSearch(val) {
      this.$refs.orderListRef.search(val)
      this.exportQuery = { ...val }
    },
    async handleExport() {
      // console.log('handleExport :>> ')
      const params = {
        status: 4,
        ...this.exportQuery
      }
      const obj = JSON.parse(JSON.stringify(params))
      let i = ''
      let url = ''
      // eslint-disable-next-line prefer-template, guard-for-in, no-restricted-syntax
      for (i in obj) url += '&' + i + '=' + obj[i]
      const downloadUrl = `${process.env.VUE_APP_REQUEST_URL}/chargePieOrder/exportExcel?${url}`
      console.log('host :>> ', downloadUrl)
      utils.download(downloadUrl, '异常订单列表')
    }
  }
}
</script>
